const Initial_State={}
const brickReducer=(state=Initial_State,action) => {    
    switch(action.type){
        case 'GET_PTYPE':
            return action.payload
        default :
            return state;
    }
}
export default brickReducer;